import React from 'react';
import { Box, Divider, Typography } from '@mui/material';
import zeplinColor from 'theme/Color';
import TodaysMeetingCard from 'components/shared/CustomDashboard/Overview/TodaysMeetingCard/TodaysMeetingCard';

export type CommitmentItem = {
  eventId: string;
  title: string;
  start: string;
  end: string;
  startFormatted: string;
  endFormatted: string;
  platform: string;
  location: string | null;
};

const UpcomingCommitmentsBox = ({ items }: { items: CommitmentItem[] }) => (
  <Box
    sx={{
      border: `1px solid ${zeplinColor.Neutral5}`,
      borderRadius: '14px',
      padding: '16px 0px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      gap: '12px',
      minHeight: '260px',
    }}
  >
    <Typography variant='responsiveHeading4' color={zeplinColor.BasicBlack} sx={{ px: '16px' }}>
      Upcoming Commitments ({items.length})
    </Typography>
    <Divider component='div' sx={{ borderColor: zeplinColor.Neutral5 }} />
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'scroll',
        height: { xs: 'calc(100vh - 1050px)', xl: 'calc(100vh - 850px)' },
      }}
    >
      {items.length === 0 ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            py: '16px',
            height: { xs: 'calc(100vh - 150px)', xl: 'calc(100vh - 250px)' },
            overflowY: 'scroll',
          }}
        >
          <img src='/assets/no-meeting.svg' width='34px' height='34px' alt='no-meetings' />
          <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
            No Upcoming Commitments
          </Typography>
        </Box>
      ) : (
        items.map((item) => (
          <TodaysMeetingCard
            key={item.eventId}
            loading={false}
            data={{
              attendees: [],
              body: '',
              end: item.end,
              location: item.location ?? '',
              meetingLink: item.location ?? '',
              organizer: item.platform,
              start: item.start,
              subject: item.title,
            }}
          />
        ))
      )}
    </Box>
  </Box>
);

export default UpcomingCommitmentsBox;
